/* Sarthi Mart draft: Gopal-style inline quantities.
   Retain Minimog's original first-add product-form and all delivery validations. */
(() => {
  if (window.SarthiCardQuantityLoaded) return;
  window.SarthiCardQuantityLoaded = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let mostRecentCart = null;
  let syncSerial = 0;

  const controls = () => document.querySelectorAll('.sarthi-card-quantity[data-sarthi-variant]');
  const getPlainLine = (cart, variantId) => {
    const items = cart && cart.items || [];
    return items.find(item =>
      String(item.variant_id) === String(variantId) &&
      !item.selling_plan_allocation &&
      true
    );
  };
  const updateCards = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    mostRecentCart = cart;
    controls().forEach(control => {
      const line = getPlainLine(cart, control.dataset.sarthiVariant);
      const quantity = line ? line.quantity : 0;
      const wrapper = control.closest('.m-product-card__action')?.querySelector('.m-product-card__action-wrapper');
      if (!wrapper) return;
      control.hidden = quantity === 0;
      control.querySelector('.sarthi-card-quantity__value').textContent = String(quantity);
      wrapper.classList.toggle('sarthi-quantity-active', quantity > 0);
    });
  };
  const refresh = async () => {
    const serial = ++syncSerial;
    try {
      const response = await fetch(root + 'cart.js', { credentials:'same-origin', headers: {'Accept':'application/json'} });
      if (!response.ok) throw new Error('Could not read cart');
      const cart = await response.json();
      if (serial === syncSerial) updateCards(cart);
    } catch (error) {
      console.warn('Sarthi quantity refresh:', error);
    }
  };
  const reportError = (message) => {
    if (window.MinimogTheme?.Notification?.show) {
      window.MinimogTheme.Notification.show({
        target:document.body, type:'error', message: message || 'Unable to update quantity. Please try again.',
        last:3000
      });
    } else {
      console.error(message || 'Unable to update quantity');
    }
  };

  // Native first-add completes before product-ajax:added fires; do not intercept it.
  document.addEventListener('product-ajax:added', () => { refresh(); });
  // Some theme app integrations complete their AJAX add without sending product-ajax:added.
  // Re-check the cart after any native product-card form submission.
  document.addEventListener('submit', event => {
    const form=event.target;
    if (form.matches?.('.m-product-card .product-card-form')) {
      setTimeout(refresh, 450);
      setTimeout(refresh, 1100);
    }
  },true);
  // Variant buttons also change which cart line this card's quantity buttons edit.
  document.addEventListener('sarthi:card-variant-changed', () => {
    if (mostRecentCart) updateCards(mostRecentCart);
    refresh();
  });
  document.addEventListener('cart:updated', () => { refresh(); });
  document.addEventListener('cart:refresh', () => { refresh(); });
  document.addEventListener('shopify:section:load', () => { if (mostRecentCart) updateCards(mostRecentCart); refresh(); });
  window.addEventListener('pageshow', () => { refresh(); });

  document.addEventListener('click', async (event) => {
    const step = event.target.closest('.sarthi-card-quantity__step');
    if (!step) return;
    const control = step.closest('.sarthi-card-quantity');
    if (!control || control.dataset.sarthiBusy === 'true') return;
    event.preventDefault();
    const variantId = control.dataset.sarthiVariant;
    control.dataset.sarthiBusy = 'true';
    const shared = [...document.querySelectorAll('.sarthi-card-quantity[data-sarthi-variant="'+variantId+'"]')];
    shared.forEach(element => element.querySelectorAll('button').forEach(button => {button.disabled=true;}));
    try {
      // Fetch the current cart before editing to avoid stale line keys or quantities.
      const beforeResponse = await fetch(root + 'cart.js', { credentials:'same-origin' });
      if (!beforeResponse.ok) throw new Error('Could not read cart');
      const before = await beforeResponse.json();
      const line = getPlainLine(before, variantId);
      if (!line) { updateCards(before); return; }
      const requested = Math.max(0, line.quantity + Number(step.dataset.sarthiStep));
      let sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {bubbles:true, detail:{sections}}));
      const response = await fetch(root + 'cart/change.js', {
        method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json', 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({id:line.key, quantity:requested, sections, sections_url:window.location.pathname})
      });
      const cart = await response.json();
      if (!response.ok || cart.status || cart.errors) throw new Error(cart.description || cart.message || cart.errors || 'Unable to update quantity');
      ++syncSerial;
      updateCards(cart);
      // Same event used by the existing cart drawer, cart badge and shipping logic.
      if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {cart});
      }
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart}}));
    } catch (error) {
      reportError(error.message);
      await refresh();
    } finally {
      control.dataset.sarthiBusy = 'false';
      shared.forEach(element => element.querySelectorAll('button').forEach(button => {button.disabled=false;}));
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
})();
